import { ApiResponse } from "../interfaces/Api";
import { BedAssignment, BedAssignmentFormValues } from "../interfaces/BedAssignmentInterface";
import { Get, Post } from "./apiHelper";

const bedAssignmentsRoot = "/api/bedAssignments";

// eslint-disable-next-line import/prefer-default-export
export const getBedAssignments = async (props: {
  resourceCentreId: number;
  active?: boolean;
  ipdId?: number;
  bedId?: number;
}): Promise<ApiResponse<Array<BedAssignment>>> => {
  const query = new URLSearchParams();
  query.append("resourceCentreId", props.resourceCentreId.toString());
  if (props?.active !== undefined) query.append("active", props.active.toString());
  if (props?.ipdId) query.append("ipdId", props.ipdId.toString());
  if (props?.bedId) query.append("bedId", props.bedId.toString());

  const response = await Get(`${bedAssignmentsRoot}?${query.toString()}`, true);
  return response.data as ApiResponse<Array<BedAssignment>>;
};

export const transferBed = async (
  data: BedAssignmentFormValues
): Promise<ApiResponse<BedAssignment>> => {
  const response = await Post(`${bedAssignmentsRoot}/transfer`, data, true);
  return response.data as ApiResponse<BedAssignment>;
};
